const paths = {
  home: "M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z",
  send: "M7 17 17 7M9 7h8v8",
  request: "M17 7 7 17M15 17H7V9",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0",
  heart: "M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z",
  copy: "M9 9h10v10H9zM5 15V5h10",
  share: "M12 4v11M8 8l4-4 4 4M5 13v6h14v-6",
  check: "m5 12.5 4.5 4.5L19 7.5",
  back: "M15 5l-7 7 7 7",
  chevron: "M9 5l7 7-7 7",
  up: "M6 15l6-6 6 6",
  down: "M6 9l6 6 6-6",
  withdraw: "M12 4v12M7 11l5 5 5-5M5 20h14",
  pay: "M4 8h16M4 8v10h16V8M4 8l2-3h12l2 3M9 13h6",
  chart: "M4 19h16M6 15l4-5 3 3 5-7",
  card: "M3 6.5A1.5 1.5 0 0 1 4.5 5h15A1.5 1.5 0 0 1 21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5zM3 10h18M7 15h4",
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3Z",
  activity: "M4 7h16M4 12h10M4 17h7",
  shield: "M12 3 5 6v5.5c0 4.3 3 7.8 7 9.5 4-1.7 7-5.2 7-9.5V6l-7-3Zm-3 9 2.2 2.2L15.5 10",
  bell: "M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0",
  code: "M8 8l-4 4 4 4M16 8l4 4-4 4M13.5 5l-3 14",
  building: "M4 20h16M6 20V9l6-4 6 4v11M10 20v-5h4v5",
} as const;

export type IconName = keyof typeof paths | "circle";

export function Icon({ name, size = 22 }: { name: IconName; size?: number }) {
  if (name === "circle") {
    // eight-bead ring, the circles tab
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
        {Array.from({ length: 8 }, (_, i) => {
          const a = ((i * 45 - 90) * Math.PI) / 180;
          return <circle key={i} cx={12 + 8 * Math.cos(a)} cy={12 + 8 * Math.sin(a)} r={i === 0 ? 2.6 : 1.7} fill="currentColor" />;
        })}
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={paths[name]} />
    </svg>
  );
}
